$responsive-logo-min-width: 30px;
$responsive-logo-image-height: 25px;
$responsive-logo-image-margin-left: 15px;
$responsive-logo-image-max-width: 150px;
$responsive-logo-image-softphone-height: 30px;

.responsive-logo {
  min-width: $responsive-logo-min-width;

  &__image {
    height: $responsive-logo-image-height;
    width: auto;
    max-width: $responsive-logo-image-max-width;

    &--softphone,
    &--small {
      height: $responsive-logo-image-softphone-height;
      width: auto;
    }

    &--softphone {
      margin-left: 0;
    }
  }
}
